/*
 *
 * OperationPayToCardDetail
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 19-Oct-2026
 */

import OperationPayToCardDetail from './OperationPayToCardDetailContainer'

export default OperationPayToCardDetail
